import React from 'react'
import healthWellbeing from "../../Images/OurWork/health-wellbeing.png";

const HealthWellbeing = () => {
  return (
    <div>
      <img src={healthWellbeing} />
    </div>
  );
}

export default HealthWellbeing
